var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "17919A46-09A7-465B-BA99-BFCE7DDA971B") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Styleguide",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-960.000000, -3215.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(127.000000, 3160.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons/search",
    transform: "translate(833.000000, 55.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8632925,17.2035624 L14.9347158,14.2750384 C15.662661,13.3996599 16.1012197,12.2755775 16.1012197,11.0507817 C16.1012197,8.2657695 13.8355198,6 11.050641,6 C8.26569995,6 6,8.2657695 6,11.0507817 C6,13.8356073 8.26569995,16.1011902 11.050641,16.1011902 C12.2753705,16.1011902 13.3995115,15.6626923 14.2748871,14.9347447 L17.2035261,17.863331 C17.294597,17.9544644 17.4140343,18 17.5334093,18 C17.6527844,18 17.7722216,17.9544644 17.8633548,17.863331 C18.0455588,17.6811264 18.0455588,17.385767 17.8632925,17.2035624 Z M6.9331036,11.0507817 C6.9331036,8.78028449 8.78021328,6.93310662 11.050641,6.93310662 C13.3210064,6.93310662 15.1680539,8.78028449 15.1680539,11.0507817 C15.1680539,13.3210924 13.3210064,15.1680836 11.050641,15.1680836 C8.78021328,15.1680836 6.9331036,13.3210924 6.9331036,11.0507817 Z",
    id: "Shape"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.58b9bccf.svg";
export { ForwardRef as ReactComponent };